module.exports = __webpack_public_path__ + "media/customizations/elevon/back-d6c1703ef38c228783d443e374a047c3.jpg";